import { PortalStore } from '../../portal/portalStore/PortalStore';
import { RequestStore } from './RequestStore';

export class RequestStoreHost {
  requestStore: RequestStore;

  constructor(requestStore) {
    this.requestStore = requestStore;
  }

  get instance() {
    return this.requestStore.requestData.instance;
  }

  get subDomain() {
    return this.requestStore.requestData.subdomain;
  }

  get hrefBase() {
    return `https://${this.subDomain}.schlaukopf.de`;
  }

  get nodeHrefBase() {
    let nodeSubdomain = `${this.requestStore.requestData.subdomain}node`;
    if (nodeSubdomain === 'wwwnode') nodeSubdomain = 'node';
    return `https://${nodeSubdomain}.schlaukopf.de`;
  }
}
